import {
  ISurveyInvite,
  ISurveyPayload,
  ISurveyQuestionPayload,
} from "../../types";
import { request } from "../../utils/axios";

export const fetchSurvey = async (page: number, limit?: number) => {
  try {
    const res = await request.get(`admin/surveys?page=${page}&limit=${limit}`);
    return res?.data;
  } catch (error: any) {
    const err = error?.response?.data;
    throw err;
  }
};

export const fetchSingleSurvey = async (id: number) => {
  try {
    const res = await request.get(`admin/surveys/${id}`);
    return res?.data;
  } catch (error: any) {
    const err = error?.response?.data;
    throw err;
  }
};

export const createSurvey = async (form: ISurveyPayload) => {
  try {
    const res = await request.post(`admin/surveys`, form);
    return res?.data?.data;
  } catch (error: any) {
    const err = error?.response?.data;
    throw err;
  }
};

export const createSurveyQuestion = async (form: ISurveyQuestionPayload) => {
  try {
    const res = await request.post(
      `admin/surveys/${form.surveyId}/questions`,
      form
    );
    return res?.data?.data;
  } catch (error: any) {
    const err = error?.response?.data;
    throw err;
  }
};

export const SurveyInviteByCourse = async ({
  surveyId,
  courseId,
}: ISurveyInvite) => {
  try {
    const res = await request.post(
      `admin/surveys/${surveyId}/courses/${courseId}/send`
    );
    return res?.data?.data;
  } catch (error: any) {
    const err = error?.response?.data;
    throw err;
  }
};
